import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import PageTransition from './components/PageTransition';
import DocumentHead from './components/DocumentHead';
import { SeoProvider, useSeo } from './contexts/SeoContext';

import Home from './pages/Home';
import About from './pages/About';
import AudioTour from './pages/AudioTour';
import Blog from './pages/Blog';
import Blog_Detail from './pages/Blog_Detail';
import Event from './pages/Event';
import Contact from './pages/Contact';
import Hours from './pages/Hours';
import KnowBeforeYouGo from './pages/KnowBeforeYouGo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Faq from './pages/Faq';
import NotFound from './pages/NotFound';
import PageResolver from './components/PageResolver';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PageLoadProvider } from './contexts/PageLoadContext';

// Valid routes for Header/Footer visibility
const validRoutes = [
  '/',
  '/about',
  '/audiotour',
  '/blog',
  '/event',
  '/contact',
  '/hours',
  '/know-before-you-go',
  '/privacy-policy',
  '/faq'
];

function AppContent() {
  const location = useLocation();
  const { pageSeo } = useSeo();

  // Check if Header & Footer should be shown
  const isValidRoute =
    validRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/blog/') ||
    location.pathname !== '/'; // Show header/footer for all pages except home (handled by specific routes)

  return (
    <div className="App">
      <DocumentHead pageSeo={pageSeo} />

      <Header />

      <PageTransition>
        <Routes >
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/audiotour" element={<AudioTour />} />
          <Route path="/blog" element={<Blog />} />
          {/* Support canonical blog URLs like /2026/03/10/slug */}
          <Route path="/:year/:month/:day/:slug" element={<Blog_Detail />} />
          <Route path="/blog/:slug" element={<Blog_Detail />} />
          <Route path="/event" element={<Event />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/hours" element={<Hours />} />
          <Route path="/know-before-you-go" element={<KnowBeforeYouGo />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/:slug" element={<PageResolver />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PageTransition>

      {isValidRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <SeoProvider>
      <PageLoadProvider>
        <AppContent />
      </PageLoadProvider>
    </SeoProvider>
  );
}

export default App;
